module.exports = __webpack_public_path__ + "img/ourTipp@2x.ee3469f.webp";